import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaThemeChangeSavePage } from './plaza-theme-change-save';

@NgModule({
  declarations: [
    PlazaThemeChangeSavePage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaThemeChangeSavePage),
    TranslateModule.forChild()
  ],
})
export class PlazaThemeChangeSavePageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-theme-change-save/plaza-theme-change-save.module.ts